import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ManageContentTemplates = ({ location }) => {
  const [templateTypes, setTemplateTypes] = useState([]);
  const [message, setMessage] = useState("");
  const {token,userMetadata}=useAuth()
  const navigate = useNavigate();
  let parms = new URLSearchParams(location.search);

  const [state, setState] = useState({
    contentTemplateId: parseInt(parms.get("id")),
    contentId: 0,
    contentTemplateTypeId: 0,
    contentTemplateName: "",
    contentTemplateDescr: "",
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");

    var url = `${globalConfig.apiDatahubUrl}/content-templates/${state.contentTemplateId}`;

    axios
      .patch(url, state, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(response.status + ":" + response.data.contentInputSourceId);

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-template-types`,
        apiHeader(token)
      )
      .then((res) => {
        const templateTypes = res.data;
        console.log(templateTypes);
        setTemplateTypes(templateTypes);
      });

    console.log("handleOnLoad() - loading id = " + state.contentTemplateId);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-templates/${state.contentTemplateId}`,
        apiHeader(token)
      )
      .then((res) => {
        const contentType = res.data;
        console.log("contentType");
        console.log(contentType);
        setState(contentType);
        console.log("state");
        console.log(state);
      });
  };

  function onDelete() {
    let deleteID = state.contentTemplateId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-templates/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        navigate(-1);
      })
      .catch((err) => console.log("Err delete:" + err));
  }
  return (
    <form>
      <div className="container-fluid">
      <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
        <h4>Manage Content Templates</h4>
        <hr />
        <h4>Selector</h4>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Choose Template">
            Choose Template
          </label>
          <select
            onchange="submit()"
            id="contentTemplates"
            className="form-control input-xlarge col-sm-8"
            value="#{contentTemplateForm.currentContentTemplate.contentTemplateId}"
            valueChangeListener="#{contentTemplateForm.get}"
          >
            <option value="#{ombUserProjectsForm.selectedContent.contentTemplateSelectList}" />
          </select>
        </div>
        <hr />
        <h4>Content Template</h4>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Object Name">
            Content Object Name
          </label>
          <input
            readOnly={true}
            id="content_id"
            className="form-control input-xlarge col-sm-8"
            value={state.contentId}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Template Type">
            Template Type
          </label>
          <select
            id="contentTemplateTypeId"
            className="form-control input-xlarge col-sm-8"
            value={state.contentTemplateTypeId}
            onChange={handleChange}
          >
            {/* <option
              value={state.contentTemplateTypeSelectList}
              onChange={handleChange}
            /> */}
            <option>Select Template Type</option>
            {templateTypes.map(
              ({ contentTemplateTypeDescr, contentTemplateTypeId }) => (
                <option
                  key={contentTemplateTypeId}
                  value={contentTemplateTypeId}
                >
                  {contentTemplateTypeDescr}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Template Object">
            Template Object
          </label>
          <input
            id="contentTemplateName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentTemplateName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Description">
            Description
          </label>
          <textarea
            id="contentTemplateDescr"
            className="form-control input-xlarge col-sm-8"
            cols="60"
            rows="5"
            value={state.contentTemplateDescr}
            onChange={handleChange}
          />
        </div>
        <hr />
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Last Updated By #{ombUserSession.getUserNameForId(contentTemplateForm.currentContentTemplate.lastUpdateUser)} on "
          >
            Last Updated By
          </label>
          <input
            className="form-control col-sm-1"
            readonly="readonly"
            value={state.lastUpdateUser}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="#{contentTemplateForm.currentContentTemplate.lastUpdateDate}"
          >
            Last Update Date
          </label>
          <input
            className="form-control col-sm-8"
            readonly="readonly"
            value={state.lastUpdateDate.slice(0, 16)}
            type="datetime-local"
          />
        </div>
        <hr />
        <button
          className="btn btn-danger"
          value="Delete"
          onClick={onDelete}
        >
          {" "}
          Delete
        </button>
        &nbsp;
        <button className="btn btn-success" value="Save" onClick={handleSave}>
          Save
        </button>
        &nbsp;

      </div>
    </form>
  );
};

export default ManageContentTemplates;
